var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-double"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.356 5.94193C13.6 5.60724 13.5266 5.13809 13.1919 4.89405C12.8572 4.65 12.388 4.72349 12.144 5.05817L7.76899 11.0582C7.52495 11.3929 7.59843 11.862 7.93312 12.1061C8.26781 12.3501 8.73696 12.2766 8.98101 11.9419L13.356 5.94193ZM10.356 5.94198C10.6 5.6073 10.5266 5.13814 10.1919 4.8941C9.85719 4.65006 9.38804 4.72354 9.14399 5.05823L5.28011 10.3573L3.27483 8.39291C2.97894 8.10305 2.50409 8.10794 2.21423 8.40384C1.92437 8.69974 1.92927 9.17459 2.22517 9.46444L4.85017 12.0359C5.00578 12.1883 5.21997 12.2656 5.43706 12.2475C5.65414 12.2295 5.85267 12.118 5.98101 11.942L10.356 5.94198Z",
    fill: "#0E7241"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check-double.06ec661cc4c2f84fa67a08d01c73ca81.svg";
export { ForwardRef as ReactComponent };